import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable()
export class DataService {

    private promoContent = new BehaviorSubject('');
    private logoContent = new BehaviorSubject('');
    private bannerContent = new BehaviorSubject('');
    private priceContent = new BehaviorSubject('');
    private attractorLoop = new BehaviorSubject('');
    private segment = new BehaviorSubject('');
    private heroTile = new BehaviorSubject('');
    private queryParameters = new BehaviorSubject('');
    private isUserConnected = new BehaviorSubject('');
    private skuIDContent = new BehaviorSubject('');

    getPromoContent(): Observable<any> {
        return this.promoContent.asObservable();
    }

    setPromoContent(message: any) {
        this.promoContent.next(message);
    }

    getLogoContent(): Observable<any> {
        return this.logoContent.asObservable();
    }

    setLogoContent(message: any) {
        this.logoContent.next(message);
    }

    getBannerContent(): Observable<any> {
        return this.bannerContent.asObservable();
    }

    setBannerContent(message: any) {
        this.bannerContent.next(message);
    }

    getPriceContent(): Observable<any> {
        return this.priceContent.asObservable();
    }

    setPriceContent(message: any) {
        this.priceContent.next(message);
    }

    getAttractorLoop(): Observable<any> {
        return this.attractorLoop.asObservable();
    }

    setAttractorLoop(message: any) {
        this.attractorLoop.next(message);
    }

    getSegment(): Observable<any> {
        return this.segment.asObservable();
    }

    setSegment(message: any) {
        this.segment.next(message);
    }

    getHeroTile(): Observable<any> {
        return this.heroTile.asObservable();
    }

    setHeroTile(message: any) {
        this.heroTile.next(message);
    }
    getQueryParameters(): Observable<any> {
        return this.queryParameters.asObservable();
    }

    setQueryParameters(message: any) {
        this.queryParameters.next(message);
    }

    getIsUserConnected(): Observable<any> {
        return this.isUserConnected.asObservable();
    }

    setIsUserConnected(message: any) {
        this.isUserConnected.next(message);
    }

    getSKUIDContent(): Observable<any> {
        return this.skuIDContent.asObservable();
    }

    setSKUIDContent(message: any) {
        this.skuIDContent.next(message);
    }
}
